var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[(_vm.$store.getters['user/getAppid'] === 'wx41c1352ffcf95479')?_c('cjl-ys'):_c('yzy-ys')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }